import React, { useEffect, useState, useRef } from 'react'
import { debounce } from 'throttle-debounce'
import { trackPromise } from 'react-promise-tracker'
import { Link } from 'react-router-dom'

import { GetToolboxDocuments } from '../../store/ContentfulClient'
import { SidebarToggle, MainContent } from '../../layouts/components/Structure'
import { GetToolboxDocumentCategories } from '../../store/ContentfulClient'

import LoadingWrapper from 'components/LoadingWrapper'
import DocumentDisplay from '../../components/DocumentDisplay'
import HelloIntroBox from '../../components/IntroBox'
import { SidebarFilter, SidebarSearch } from '../../components/SearchAndFilter'
import BackToPortal from '../../components/BackToPortal'

const Tools = () => {
    const ToolboxPromiseArea = 'toolbox-list'
    const SidebarPromiseArea = 'toolbox-sidebar'

    const [categories, setCategories] = useState([])
    const [documents, setDocuments] = useState([])

    const [typingSearchString, setTypingSearchString] = useState('')
    const [searchString, setSearchString] = useState('')
    const [selectedCategory, setSelectedCategory] = useState('')

    const [dropdownFilter, setDropdownFilter] = useState('all')
    const [subCatgoriesDropdown, setSubCatgoriesDropdown] = useState([])

    const realSearch = useRef(
        debounce(250, (value) => {
            setSearchString(value)
        })
    ).current

    const refreshState = () => {
        setTypingSearchString('')
        setSearchString('')
        setSelectedCategory('')
    }

    useEffect(() => {
        trackPromise(
            GetToolboxDocumentCategories().then((items) => {
                setCategories(items)
            }),
            SidebarPromiseArea
        )
    }, [])

    useEffect(() => {
        const SearchDocuments = () => {
            trackPromise(
                GetToolboxDocuments(searchString, selectedCategory).then((loadedDocs) => {
                    setDocuments(loadedDocs)
                    mapDocuments(loadedDocs)
                }),
                ToolboxPromiseArea
            )
        }

        SearchDocuments()
    }, [searchString, selectedCategory])

    const mapDocuments = (docs) => {
        let result = {}
        let total = 0

        for (const {
            fields: {
                subCategory: { fields: { name: subname, order }, sys: { id } } = {
                    fields: {},
                    sys: {},
                },
            },
        } of docs) {
            if (!result[id]) result[id] = { subname, count: 0, order }
            result[id].count = result[id].count += 1
            total += 1
        }

        let categorySelected = [
            { value: 'all', label: 'All Documents', count: total, key: 'all', order: -1 },
        ]

        for (const key of Object.keys(result)) {
            categorySelected.push({
                value: key,
                label: result[key].subname ?? 'General',
                count: result[key].count,
                key,
                order: result[key].order ?? 0,
            })
        }
        categorySelected = categorySelected.sort((a, b) => (a.order > b.order ? 1 : -1))

        setSubCatgoriesDropdown(categorySelected)

        return result
    }

    const filterDocumentsBySubCategory = () => {
        //filter in memory
        const filter = dropdownFilter
        const docs = documents

        if (!filter || filter === 'all' || docs.length === 0) {
            return documents
        } else if (filter === 'undefined') {
            return docs.filter((_) => !_.fields.subCategory)
        } else {
            return docs.filter(
                (_) => _.fields.subCategory && _.fields.subCategory.sys.id === filter
            )
        }
    }

    const inputChanged = (value) => {
        setTypingSearchString(value)
        realSearch(value)
    }

    return (
        <>
            <SidebarToggle>
                <Link to="/tools" onClick={refreshState} className="layer-header">
                    <h1>Tools</h1>
                </Link>
                <HelloIntroBox type="Tools" />
                <BackToPortal />
                <SidebarFilter
                    selectedFilter={selectedCategory}
                    selectedFilterChange={setSelectedCategory}
                    promiseArea={SidebarPromiseArea}
                    filters={categories}
                />
            </SidebarToggle>
            <MainContent>
                <div className="col-section col-no-margin">
                    <div className="col-xs-6">
                        <form id="client-select">
                            <select
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event
                                    setDropdownFilter(value)
                                }}
                            >
                                {subCatgoriesDropdown &&
                                    subCatgoriesDropdown.map(({ value, label, key, count }) => {
                                        return (
                                            <option key={key} value={value}>
                                                {label} ({count})
                                            </option>
                                        )
                                    })}
                            </select>
                        </form>
                    </div>
                    <div className="col-xs-6">
                        <SidebarSearch
                            searchPlaceholder="Search your materials"
                            searchChange={inputChanged}
                            searchString={typingSearchString}
                        />
                    </div>
                </div>
                <LoadingWrapper area={ToolboxPromiseArea}>
                    <DocumentDisplay documents={filterDocumentsBySubCategory(documents)} />
                </LoadingWrapper>
            </MainContent>
        </>
    )
}

export default Tools
